<template>
  <footer class="footer__wrapper text-light-gray">
    <footer-content />

    <footer-terms />
  </footer>
</template>

<script>
import FooterTerms from '@/components/_layout/AFooter/FooterTerms/index.vue'
import FooterContent from '@/components/_layout/AFooter/FooterContent/index.vue'

export default {
  name: 'AFooter',
  components: { FooterContent, FooterTerms }
}
</script>

<style lang="scss" scoped>
.footer__wrapper {
  $padding: (
    $above-desktop-xl: 100px 0 50px,
    $tablet: 64px 0,
    $mobile: 32px 0
  );

  @include setStyleByBreakpoint('padding', $padding);
}
</style>
